import Vue from 'vue';
import VueResize from 'vue-resize';
import 'vue-resize/dist/vue-resize.css';

Vue.use(VueResize);
